import { useLingui } from '@lingui/react/macro';
import { theme } from 'styles/theme/theme';
import { UDFormDropzone } from 'ud-form/components/image-dropzone';

/**
 * Поле «Фото» публичной заявки.
 *
 * Своей обработки здесь больше нет: сжатие, предел на исходный файл и объяснение
 * HEIC живут внутри самой дропзоны (`ud-form/components/image-compression`) и
 * работают одинаково во всех формах, а не только в этой.
 *
 * Подпись белая, потому что публичная заявка живёт на тёмном фоне — в отличие от
 * остальных форм админки.
 */
const PhotoField = () => {
  const { t } = useLingui();

  return (
    <UDFormDropzone
      name="photo"
      label={t`Фото (не обязательно).\nБольшое фото сожмём автоматически`}
      labelProps={{ className: 'mb-2 whitespace-pre-wrap', style: { color: theme.colors.SurfaceWhite } }}
      crop
      removable
      className="p-6"
    />
  );
};

export default PhotoField;
